<div class="container-fluid p-0">
  <div class="authentication-main">
    <div class="row">
      <div class="col-md-12 p-0">
        <div class="auth-innerright">
          <div class="authentication-box">
            <div class="card mt-4">
              <div class="card-header bg-info">
                <div class="text-center"><img src="../../../assets/images/logo/logo-inniver-small.png" alt=""></div>
              </div>
              <!-- <form class="theme-form"> -->
                <div class="card-body bg-grey">
                  <form class="ngx-form" [formGroup]="unlockForm" novalidate>
                    <div class="form-row">
                      <div class="col-md-12 mb-3">
                        <div class="form-group">
                          <label class="control-label" for="f1-password">Enter password</label>
                          <input type="password" formControlName="password" class="form-control" autocomplete="off"
                            placeholder="enter your password.." (keyup)="onKey($event)">
                          <div
                            *ngIf="unlockForm.controls['password'].invalid && (unlockForm.controls['password'].dirty || unlockForm.controls['password'].touched)"
                            class="alert">
                            <div *ngIf="unlockForm.controls['password'].errors?.['required']">
                              Password is required.</div>
                            <div *ngIf="unlockForm.controls['password'].errors?.['minlength']">Password must be at least 8 characters</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <div class="f1-buttons">
                        <button class="btn btn-pill btn-primary btn-submit" type="submit" [disabled]="!unlockForm.valid"
                          (click)="onUnlock()">Submit
                        </button> 
                      </div>                     
                      <div class="form-group">
                        <div class="col-md-12" *ngIf="isLoginFailed">
                          <label class="control-label" for="f1-password">Oops...</label>
                          <div class="text-center alert alert-danger">Login failed: {{ errorMessage }}</div>
                        </div>
                      </div> 
                    </div>
                  </form>
              </div>
              <!-- </form> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>